import React from 'react';
import {useTranslation} from 'next-i18next';

export default function Partners({partners}) {

  const {t: translatePages} = useTranslation('pages');

  return (
      <>
        <center
            className={'w-full text-gray-50 bg-gradient-to-r from-gray-900  via-gray-700 to-gray-900'}>
          <h2 className={'uppercase font-title tracking-wide text-3xl my-8 p-8'}>
            {translatePages('CATEGORY.INTERIOR')}
          </h2>
        </center>
      </>
  );
}